import { shouldSkipNetworkRequest } from 'modules/utils/RequestStateUtils';
import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import Logger from 'services/Logger';

/**
 * Middleware used to prevent redundant network request calls
 * based on the request state of previous network requests.
 * Requires useRequestState and requestStateSelector
 */
const redundantRequestManager: Middleware<Dispatch> = (store: MiddlewareAPI) => (
  next: Dispatch
) => (action: AnyAction) => {
  const state = store.getState();
  const useRequestState = action?.payload?.useRequestState;
  const requestStateSelector = action?.payload?.requestStateSelector;

  if (
    useRequestState &&
    requestStateSelector &&
    shouldSkipNetworkRequest(requestStateSelector(state))
  ) {
    Logger.log('NETWORK REQUEST ACTION SKIPPED', action);
    return null;
  }

  return next(action);
};
export default redundantRequestManager;
